import { omit } from "lodash";

import { ClikDataFormOut } from "../../components/ClikDataInfoForm/types.ts";
import {
  ClikDataCategory,
  CreateClikCompanyDataInput,
  CreateClikDataInput,
  CreateClikLimitRequestDataInput,
  CreateLimitRequestGroupInput,
  CreateLimitRequestPengurusInput,
  InputMaybe,
  PengurusStatus,
} from "../../graphql/generated.ts";
import { RawGroup } from "../../types/clikData/group.ts";
import { RawPengurus } from "../../types/clikData/pengurus.ts";

const formatToCreatePengurusInput = (
  penguruses: RawPengurus[]
): CreateLimitRequestPengurusInput[] => {
  return penguruses.map((item): CreateLimitRequestPengurusInput => {
    return {
      ...omit(item, ["city", "country"]),
      cityId: Number(item.city.id),
      countryId: Number(item.country.id),
      ktpPengurus: item.ktpPengurus.filePath,
      status: PengurusStatus.Active,
    };
  });
};

const formatToCreateGroupInput = (
  groups: RawGroup[]
): CreateLimitRequestGroupInput[] => {
  return groups.map((item) => {
    return {
      ...omit(item, ["city", "country"]),
      cityId: Number(item.city.id),
      countryId: Number(item.country.id),
      npwpFile: item.npwpFile.filePath,
      registrationForm: item.registrationForm.filePath,
    };
  });
};

const formatToCreateLimitRequestInput = (
  data: ClikDataFormOut
): InputMaybe<CreateClikLimitRequestDataInput> => {
  if (data.category === ClikDataCategory.ClikRequest) {
    return null;
  }

  return {
    limitRequestAmount: data.limitRequestAmount,
    tenorRequest: Number(data.tenorRequest),
    suratPengajuanLimit: data.suratPengajuanLimit.filePath,
    formLOI: data.formLOI.filePath,
    supportingDocument: data?.supportingDocument?.filePath ?? "",
    limitRequestType: data.limitRequestType,
    limitName: data.limitName,
  };
};

export const formatToCreateCompanyDataInput = (
  data: ClikDataFormOut
): CreateClikCompanyDataInput => {
  return {
    bussinessIdentifyNumber: data.bussinessIdentifyNumber,
    phone: data.phone,
    npwpCompany: data.npwpCompany.filePath,
    npwpAddress: data.npwpAddress,
    subDistrict: data.subDistrict,
    district: data.district,
    cityId: data.city.id,
    postalCode: data.postalCode,
    countryId: data.country.id,
    formLOI: data.formLOI.filePath,
  };
};

export const formatToCreateClikDataInput = (
  data: ClikDataFormOut,
  penguruses: RawPengurus[],
  groups: RawGroup[]
): CreateClikDataInput | null => {
  return {
    companyId: data.company.id,
    category: data.category,
    companyData: formatToCreateCompanyDataInput(data),
    limitRequest: formatToCreateLimitRequestInput(data),
    penguruses: penguruses?.length
      ? formatToCreatePengurusInput(penguruses)
      : [],
    groups: groups?.length ? formatToCreateGroupInput(groups) : [],
  };
};
